import { render, staticRenderFns } from "./LeaveDayReview.vue?vue&type=template&id=0b61bdb6&"
import script from "./LeaveDayReview.vue?vue&type=script&lang=js&"
export * from "./LeaveDayReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports